import { FormGroup, ColorInput } from 'shared'
import { connect } from 'formik'

export const FormColorInput = connect(({
  field,
  form,
  formik,
  transparentOption = false,
  ...props
}) => {
  return <FormGroup field={field} form={form} {...props}>
    <ColorInput
      onColorChange={({ hex }) => formik.setFieldValue(field.name, hex)}
      transparentOption={transparentOption}
      value={field.value || 'transparent'}
    />
  </FormGroup>
})
